module.exports = __webpack_public_path__ + "media/staff/anessa-valdez-craddle-roll-39411034.jpg";